import * as React from "react";

type CloudCheckResultType = {
  cloudCheck: "pending" | "loading" | "done";
  isHasuraCloud: boolean | null;
};

export function useCloudCheck(endpoint: string) {
  const [{ cloudCheck, isHasuraCloud }, setResult] =
    React.useState<CloudCheckResultType>({
      cloudCheck: "pending",
      isHasuraCloud: null,
    });

  React.useEffect(() => {
    if (endpoint.length) {
      setResult({ cloudCheck: "loading", isHasuraCloud: null });
      fetch(new URL(endpoint).origin + "/v1/version")
        .then((res) => res.json())
        .then((data) => {
          if (data.version && data.version.includes("cloud"))
            setResult({ cloudCheck: "done", isHasuraCloud: true });
          else setResult({ cloudCheck: "done", isHasuraCloud: false });
        })
        .catch(() => setResult({ cloudCheck: "done", isHasuraCloud: false }));
    }
  }, [endpoint]);

  return { cloudCheck, isHasuraCloud };
}
